export const queryKeys = {
  category: 'category',
  list: 'list',
}
